/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddUserToSpaceRequest } from '../../models/add-user-to-space-request';
import { AddUserToSpaceResult } from '../../models/add-user-to-space-result';

export interface ApiSpacesIdUsersPost$Params {
  id: string;
      body?: AddUserToSpaceRequest
}

export function apiSpacesIdUsersPost(http: HttpClient, rootUrl: string, params: ApiSpacesIdUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddUserToSpaceResult>> {
  const rb = new RequestBuilder(rootUrl, apiSpacesIdUsersPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddUserToSpaceResult>;
    })
  );
}

apiSpacesIdUsersPost.PATH = '/api/Spaces/{id}/users';
